module.exports = __webpack_public_path__ + "static/img/n-task-status.9e8e16c1.png";